import { ComparatorContext, usePage } from '@kizi/comparator-core';
import { Div, DivProps } from '@kizi/core-components';
import { Radio, RadioProps } from '@kizi/shared-components';
import React, { useContext, useMemo } from 'react';

export interface RadioGroupProps extends Omit<DivProps, 'value'> {
  name: string;
  value?: RadioProps['value'];
  subLabel?: string;
  radios: RadioProps[];
  containerProps?: DivProps;
  onClick?: React.MouseEventHandler;
}

const defaultContainerProps = {
  display: 'flex',
  alignItems: 'center',
};

const getPrice = (value, radios) => {
  return radios.filter((el) => el.value === value)[0]?.extraLabel;
};

export const CustomRadioGroup: React.FC<RadioGroupProps> = ({
  radios,
  onChange,
  onClick,
  value,
  name,
  subLabel,
  containerProps,
  variant,
  ...divProps
}) => {
  const context = useContext(ComparatorContext);
  const comparatorName = context.name;
  const { state, setState } = usePage();

  const _radios = useMemo(() => {
    return (radios ?? []).map((radioProps, i) => {
      const conditionalVariant = variant ? { variant } : {};
      return (
        <Div
          key={`radio-${name}-${i}`}
          display="flex"
          justifyContent="space-between"
          alignItems="end"
        >
          <Radio
            containerProps={{
              ...defaultContainerProps,
              ...containerProps,
              ...radioProps.containerProps,
            }}
            {...radioProps}
            {...conditionalVariant}
            name={name}
            checked={
              value === radioProps.value?.toString() && !radioProps.disabled
            }
            onChange={(e) => {
              if (onChange) onChange(e);
              if (comparatorName === 'os-solar-panels') {
                if (state && setState) {
                  setState({
                    ...state,
                    costs: {
                      ...(state?.costs as object),
                      [name]: getPrice(e.target.value, radios),
                    },
                  });
                }
              }
            }}
            onClick={(e) => {
              if (onClick) onClick(e);
            }}
          />
          {radioProps?.extraLabel ? radioProps.extraLabel : null}
        </Div>
      );
    });
  }, [state, radios, value, name, containerProps]);

  return (
    <Div {...divProps}>
      {subLabel}
      {_radios}
    </Div>
  );
};
